<script>
    let url = '';
    
    export let selector_category_product_element = '';
    export let selector_category_product_title = '';
    export let selector_category_product_image = '';
    export let selector_category_product_description = '';
    export let selector_category_product_price = '';
    export let selector_category_product_vendorcode = '';

    export let change_url;
    export let find_selector;
</script>

<div class="section-title">Селекторы продуктов [в категории]</div>
<div class="wide-block pb-2">
    <div class="row">
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Адрес категории</span>
                    <input type="url" class="form-control" placeholder="http://example.com/catalog" bind:value={url} on:change={() => change_url(url)}/>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор элемента</span>
                    <input type="text" class="form-control" placeholder=".product" bind:value={selector_category_product_element} on:change={() => {find_selector(url, selector_category_product_element)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор заголовка</span>
                    <input type="text" class="form-control" placeholder="h1" bind:value={selector_category_product_title} on:change={() => {find_selector(url, selector_category_product_element + ' ' + selector_category_product_title)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор изображения</span>
                    <input type="text" class="form-control" placeholder="img.photo" bind:value={selector_category_product_image} on:change={() => {find_selector(url, selector_category_product_element + ' ' + selector_category_product_image)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор описания</span>
                    <input type="text" class="form-control" placeholder="div.description" bind:value={selector_category_product_description} on:change={() => {find_selector(url, selector_category_product_element + ' ' + selector_category_product_description)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор стоимости</span>
                    <input type="text" class="form-control" placeholder="span.price" bind:value={selector_category_product_price} on:change={() => {find_selector(url, selector_category_product_element + ' ' + selector_category_product_price)}} />
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <span>Селектор артикула</span>
                    <input type="text" class="form-control" placeholder="span.vendorcode" bind:value={selector_category_product_vendorcode} on:change={() => {find_selector(url, selector_category_product_element + ' ' + selector_category_product_vendorcode)}} />
                </div>
            </div>
        </div>
    </div>
</div>
